import { newToolFilterOAuthMcp } from "../oauth.ts";

export const readAiMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/614e5e239ea0f25fe5b6a797/615f71de842b191ea061fda6_ReadLogomark_256x256.png",
  url: "https://api.read.ai/mcp",
  label: "Read AI",
});
